// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1MIrw","info":"Note_info__3ERiY","note":"Note_note__yikQD","actions":"Note_actions__2ZisB"};